import { datadogLogs } from "@datadog/browser-logs";
import { isValidUuid } from "@/util/uuid";
import { learningServiceRequest, skip } from "./utils";

const programsPageService = {
  async getProgramPages({ limit = 10, page = 1, q = "", source, extraParams = {} }) {
    return await learningServiceRequest({
      method: "get",
      url: "/programming/program_pages",
      source,
      params: {
        limit,
        skip: skip(page, limit),
        q,
        ...extraParams,
      },
      failureMessage: "Error loading programs data",
    });
  },
  async getProgramPage(id, params = {}) {
    if (!isValidUuid(id)) {
      datadogLogs.logger.warn("invalid_program_page_id_rejected", {
        event_name: "invalid_program_page_id_rejected",
        program_page_id_raw: String(id),
      });
      throw new Error(`Invalid UUID passed to Learning Service "getProgramPage", Value="${id}"`);
    }
    return await learningServiceRequest({
      method: "get",
      url: `/programming/program_pages/${id}`,
      params: params,
      failureMessage: "Error loading program page data",
    });
  },
  async updateProgramPage(programPageId, payload) {
    return await learningServiceRequest({
      method: "put",
      url: `/programming/program_pages/${programPageId}`,
      payload: payload,
      failureMessage: "Error updating program page data",
    });
  },
  async createProgramPage(payload) {
    return await learningServiceRequest({
      method: "post",
      url: `/programming/program_pages/`,
      payload: payload,
      failureMessage: "Error creating program page data",
    });
  },
};

export default programsPageService;
